import * as React from "react";
import { RenameDialog } from "@/components/modals/RenameDialog";
import { useReactHookFormAxiosValidation } from "@/hooks/use-react-hook-form-axios-validation";
import { useUpdateBusinessReportOutcomeMutation } from "../../businessReports.api";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  businessReportOutcome: BusinessReportOutcome;
}

export const RenameSnapshotModal: React.FC<Props> = ({ isOpen, setIsOpen, businessReportOutcome }) => {
  const [updateBusinessReportOutcome] = useUpdateBusinessReportOutcomeMutation();
  const handleReactHookFormAxiosValidation = useReactHookFormAxiosValidation<{ name: string }>();

  return (
    <RenameDialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Rename SnapShot"
      placeholder="Enter snapshot name"
      initialName={businessReportOutcome.name}
      successMessage="Snapshot renamed"
      onRename={async name => {
        await updateBusinessReportOutcome({ id: businessReportOutcome.id, data: { name } }).unwrap();
      }}
      onError={handleReactHookFormAxiosValidation}
    />
  );
};
